/* Built In Imports */
import { useContext, useEffect } from 'react';

/* External Imports */
import { Box, ChakraProvider } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import config from '@config';
import PageConfig from '@lb/Common/PageConfig';
import RenderSections from '@lb/Common/RenderSections';
import WrapLayout from '@lb/components/Layout/WrapLayout';
import Breadcrum from '@lb/components/Navigation/Breadcrum';
import HeadComponent from '@lb/components/Utility/HeadComponent';
import { AuthContext } from '@store/auth-context';

/* Services */
import { getLocale } from '@msr/components/Utility/Shared/SharedService';
import {
  fetchFooterDetailData,
  fetchHeaderMenuData,
} from 'services/commonService';
import { fetchDetails, getLandingPaths } from 'services/lbService';

/* Styles */
import { lingaBhairaviTheme } from '@styles/theme';

/**
 *
 * @param {object} pageData
 * @param lang
 * @param region
 * @returns
 */

const Events = ({ pageData, region, lang }) => {
  const authContext = useContext(AuthContext);

  // const schemaData = {
  //   '@context': 'https://schema.org',
  //   '@type': 'Event',
  //   name: pageData?.title,
  //   description: pageData?.summary,
  //   image: pageData?.body[0]?.sectionContent[0]?.desktopImage?.url,
  //   startDate: render(pageData?.body[0]?.sectionContent[0]?.date),
  //   endDate: render(pageData?.body[0]?.sectionContent[0]?.date),
  //   eventAttendanceMode: 'https://schema.org/MixedEventAttendanceMode',
  //   location: pageData?.locations?.map(loc => {
  //     return {
  //       '@type': 'Place',
  //       name: loc.title,
  //       address: {
  //         '@type': 'PostalAddress',
  //         streetAddress: loc.title,
  //         addressLocality: loc.title,
  //         // 'postalCode': '641114',
  //         // 'addressCountry': 'IN'
  //       },
  //     };
  //   }),
  // };

  useEffect(() => {
    authContext.RegionAndLang(region, lang);
  }, [authContext, region, lang]);

  return (
    <WrapLayout pageData={pageData}>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>
      {pageData?.breadcrumbs?.length > 0 && (
        <Breadcrum
          page={pageData.breadcrumbs}
          alsoin={pageData.alsoin}
          url=""
          region={region}
          lang={lang}
        />
      )}
      <ChakraProvider resetCSS theme={lingaBhairaviTheme}>
        <Box
          as="section"
          background={`url(${config.imgPath}/d/46272/1682095879-white-texture-final.png)`}
          className="container-article"
          p="0"
        >
          {pageData.body?.map(section => {
            return (
              <RenderSections
                pageData={pageData}
                section={section}
                region={region}
                lang={lang}
                key={nanoid(4)}
              />
            );
          })}
        </Box>
      </ChakraProvider>
      <PageConfig isLikeVisible={false} pageData={pageData} />
      {/* <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      /> */}
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const lbPaths = config.USE_LOCAL_URL
    ? [
      `/linga-bhairavi/in/en/events/thaipusam`,
      `/linga-bhairavi/in/en/events/mahalaya-amavasya`,
      `/linga-bhairavi/in/en/events/diwali-karthigai-deepam`,
      `/linga-bhairavi/in/en/events/navratri`,
      `/linga-bhairavi/in/en/events/chitra-purnima`,
      `/linga-bhairavi/in/en/events/gobi-consecration-day`,
      `/linga-bhairavi/in/en/events/guru-purnima`,
      `/linga-bhairavi/np/en/events/guru-purnima`,
      `/linga-bhairavi/in/en/events/salem-lingabhairavi-consecration-day`,
      `/linga-bhairavi/global/en/events/thaipusam-at-linga-bhairavi`,
    ]
    : await getLandingPaths('L2', '/events/');
  return {
    paths: lbPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, lang, event },
}) => {
  const topMenuData = await fetchHeaderMenuData(
    getLocale(region, lang, 'lb'),
    'lbtopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, lang, 'lb'),
    'lbmainmenu'
  );
  const footerData = await fetchFooterDetailData(
    getLocale(region, lang, 'lb'),
    'lbfooter'
  );
  const pageData = await fetchDetails(region, lang, `events/${event}`, {
    preview,
    data: previewData,
  });

  return {
    props: {
      headerMenuData: headerMenuData?.data || null,
      footerData: footerData?.data || null,
      topMenuData: topMenuData,
      pageData: pageData || null,
      isPreview: preview ? true : false,
      region: region,
      lang: lang,
      menuType: 'lb',
    },
  };
};

export default Events;
